<div class="button-group__wrapper button-group__wrapper--align-{{align}}">
  <ng-content></ng-content>
</div>
